<template>
  <settings-modal
    class="send-nonreceipt-claim-modal t-send-nonreceipt-claim-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Claim of non-receipt</span>

    <v-textarea
      v-model="form.instructions"
      class="t-instructions-field"
      label="Instructions for Assignee"
      hint="Required field"
      rows="3"
      persistent-hint
      :error-messages="getValidationErrorMessage('instructions')"
    />

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-send-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onSendButtonClick"
      >send</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  // Events
  import { EVENT_PAYMENT_UPDATE } from '@/events/payments'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'SendSepaNonreceiptClaimModal',
    components: {
      SettingsModal,
      ErrorAlert
    },
    mixins: [form, modal, flashMessages],
    data () {
      return {
        form: {
          instructions: null
        },
        requiredFields: ['instructions'],
        sendNonreceiptClaimApiRequest: new ApiRequest(PaymentApi.sendSepaNonreceiptClaim)
      }
    },
    computed: {
      paymentId () {
        return this.modal.data.payment.id
      },
      loading () {
        return this.sendNonreceiptClaimApiRequest.loading
      },
      error () {
        return this.sendNonreceiptClaimApiRequest.error
      }
    },
    methods: {
      onSendButtonClick () {
        this.sendNonreceiptClaimApiRequest
          .execute(this.paymentId, this.parsedFormInput)
          .then(() => {
            this.$eventHub.$emit(EVENT_PAYMENT_UPDATE)

            this.showSuccessFlashMessage('Claim has been successfully send.')
          })
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>
